module.exports = __webpack_public_path__ + "static/media/home17.d70e86f2.jpg";